import React from "react";
import "twin.macro";

const PortfolioSection = () => {
  return (
    <div>
      <div tw="md:(max-w-5xl my-14 mx-auto)   text-center md:text-left text-white p-5">
        <div tw="mx-auto text-3xl text-center font-bold py-3 ">
          Why you need digital Portfolio??
        </div>
        <div tw="mx-auto space-y-4 ">
          <p>
            Digital Portfoliois one of the most efficient way to present your
            skill to a client or a job which you are looking for this portfolio
            not only tells about your skill but also about your story and most
            important projects.
          </p>
        </div>
        <div tw="mx-auto text-3xl text-center font-bold py-3 ">
          How is this a better way to represent yourself?
        </div>
        <div tw="mx-auto space-y-4 ">
          <p>
            As this gives a direct view about you and your project to the
            interviewer or your clients which shows them howdedicated you are
            towards your goals and about you skills.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSection;
